import React, {useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector, useDispatch } from 'react-redux';
import { setContent, removeContent } from './AddProgramSlice';
import styles from './ProgramManagement.module.css';
import ManagementDropdownCard from '../../components/ManagementDropdownCard';
import MultiSelectDropdown from '../../components/MultiSelectDropdown';
import { getInitialStartTime, initSelectedContent } from '../../utils/programUtils';

const ContentSetup = ({errors }) => {
    const {groupId} = useSelector((state)=>state.addProgram.program);
    const allContent = useSelector((state)=>state.programTemplateLists.content);
    const filteredContent = allContent.filter((content)=>content.groupId === groupId);
    
    const dispatch = useDispatch();
    const programContent = useSelector((state)=>state.addProgram.contents);
    const [selectedContent, setSelectedContent] = useState(initSelectedContent(programContent, allContent));

    const checkSelectedItem = (id) => {
        let contentInList = false;
        selectedContent.forEach((item)=>{
            if (item.id===id){
                contentInList=true;
            } 
        });
        return contentInList;
    };

    const handleContentChange = (content) => {
        let contentInList = false;
        selectedContent.forEach((item)=>{
            if (item.id===content.id){
                contentInList = true;
            } 
        });
        if (contentInList){
            setSelectedContent(selectedContent.filter(item => item.id !== content.id));
            dispatch(removeContent(content.id))
        } else {
            setSelectedContent([content, ...selectedContent]);
            let id = content.id;
            dispatch(setContent({
                id, 
                startTime: getInitialStartTime(),
                frequency: 1,
                interval: "Day"
            }));
        }
    };

    const removeContentCard = (id) => {
        setSelectedContent(selectedContent.filter(item => item.id !== id));
        dispatch(removeContent(id));
    };

    return (
        <div style={{display:"flex", flexDirection:"column", gap:"10px", paddingBottom:"10px"}}>
            <MultiSelectDropdown 
                options={filteredContent}
                label='name'
                checkedKey='id'
                checkSelectedItem={checkSelectedItem}
                handleChange={handleContentChange}
                selectedItems={selectedContent}
                name='Content'
            />
            {errors.contentShowing && 
                <div className={styles.ValidationMessageContainer}>
                    <FontAwesomeIcon icon="fa-solid fa-triangle-exclamation" size="xs" style={{color:"red"}}/>
                    <span 
                        className={styles.ValidationMessage}
                    >
                        {errors.contentMessage}
                    </span>
                </div>
            }
            <div style={{display:"flex", flexDirection:"column", gap:"10px"}}>
                {selectedContent.map((content, index) => (
                    <div key={content.id}>
                        <ManagementDropdownCard 
                            open={index===0} 
                            cardInfo={{title:content.name, id:content.id, type:"Content"}}
                            removeHandler={removeContentCard}
                            updateHandler={setContent}
                            dataList={programContent}
                            errorShowing={errors.contentShowing}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default ContentSetup;